import React from "react";

const TRACK_WIDTH = 40;
const THUMB_SIZE = 14;
const THUMB_OFFSET = 2;

export const STATE_NONE = "none";
export const STATE_INCLUDE = "include";
export const STATE_EXCLUDE = "exclude";

export default function TriStateSwitch({ value = STATE_NONE, onChange }) {
  // Position du knob : gauche = exclure, centre = neutre, droite = inclure
  const getKnobX = () => {
    const range = TRACK_WIDTH - THUMB_SIZE - THUMB_OFFSET * 2;
    if (value === STATE_EXCLUDE) return THUMB_OFFSET;
    if (value === STATE_INCLUDE) return THUMB_OFFSET + range;
    return THUMB_OFFSET + range / 2; // centre
  };

  // Couleurs par état
  const getTrackBg = () => {
    if (value === STATE_INCLUDE) return "#2e7d32";
    if (value === STATE_EXCLUDE) return "#CC0000";
    return "#d0d0d0";
  };

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const third = TRACK_WIDTH / 3;
    if (x < third) onChange(STATE_EXCLUDE);
    else if (x > third * 2) onChange(STATE_INCLUDE);
    else onChange(STATE_NONE);
  };

  return (
    <div
      onClick={handleClick}
      title={
        value === STATE_INCLUDE
          ? "Inclus — clic pour changer"
          : value === STATE_EXCLUDE
          ? "Exclu — clic pour changer"
          : "Neutre — clic pour inclure/exclure"
      }
      style={{
        display: "inline-flex",
        alignItems: "center",
        width: TRACK_WIDTH,
        height: THUMB_SIZE + THUMB_OFFSET * 2,
        borderRadius: 10,
        background: getTrackBg(),
        cursor: "pointer",
        position: "relative",
        flexShrink: 0,
        transition: "background 0.2s",
        userSelect: "none",
        opacity: value === STATE_NONE ? 0.6 : 1,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: THUMB_OFFSET,
          left: getKnobX(),
          width: THUMB_SIZE,
          height: THUMB_SIZE,
          borderRadius: "50%",
          background: "#fff",
          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
          transition: "left 0.2s ease",
        }}
      />
    </div>
  );
}
